import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/spiritual/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const FuneralLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0,1]);

  const renderAccordionTips = () => {
    return (
      <>  
      <Segment raised className={styles.learnMoreOverviewTextBox} >
        <p className={styles.learnMoreAccordionTextEmphasis}>Funeral Planning can be an Emotional Process.</p>
        <p className={styles.learnMoreAccordionText} > 
          Many older adults are eager to talk with adult children and family members about funerals and their preferences but
          find that the adult children and family members are reluctant to do so. Such planning asks families to face mortality 
          and clarify the meaning of dying.</p>
        <p className={styles.learnMoreAccordionText} > 
          has provided some helpful tips on topics to discuss with the older adult if you are unsure of 
          where to get started. </p>   
      </Segment>  
      <Grid stackable className={styles.learnMoreFullDiv} >
        <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
          <Grid.Column width={5} stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}Candles3.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} `} />
                <p className={styles.highlightsItemHeaderTitle} >MEMORIAL & GATHERINGS</p>
                <Header.Subheader> 
                  <p className={styles.learnMoreAccordionText} >
                  Prepare for the memorial and gatherings with the older adult so they can help choose important details about  their memorial service. They can choose the readings and songs that best represent them. <br/>
                  They also may want to have a say in what happens during the gathering after the services. Do they want a big celebration of life, or would they prefer something more intimate and low-key with those who were closest to them?</p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
          <Grid.Column width={4}  stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}ComfortIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >DECISION ON REMAINS</p>
                <Header.Subheader>  
                  <p className={styles.learnMoreAccordionText} >
                  Deciding what they want done with their remains is a very personal choice. Some older adults may already know what they want. Others may need time to consider. The default option is a standard funeral and burial, but other options like cremation are becoming more popular as well.
                  </p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
          <Grid.Column stretched doubling className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}ArrangementsIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                <p className={styles.highlightsItemHeaderTitle} >MAKE ARRANGEMENTS</p>
                <Header.Subheader> 
                  <p className={styles.learnMoreAccordionText} >
                  Advance planning  can ensure the older adult's wishes are carried out, while also ensuring that family members are not scrambling to make decisions and arrangements while they are mourning the loss of their loved one.
                  <br/>
                  Work with the older adult to choose a funeral home or cremation service. Find a venue for the wake/memorial service, and explore the costs associated with each. Many funeral services allow for payment in advance and will provide paperwork so everything will already be handled before the older adult passes.</p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
      </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Funeral Planning Tips </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];
  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}FuneralWishesLearnMore1.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );   
};

export default observer(FuneralLearnMore);
